import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import { OrderType } from 'Type/Order.type';

import NewIssuePopup from './NewIssuePopup.component';
import { CLIENT_ISSUE_POPUP_ID } from './NewIssuePopup.config';

/** @namespace PeggysagePwa/Component/NewIssuePopup/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    payload: state.PopupReducer.popupPayload[CLIENT_ISSUE_POPUP_ID] || {}
});

/** @namespace PeggysagePwa/Component/NewIssuePopup/Container/mapDispatchToProps */
export const mapDispatchToProps = () => ({});

/** @namespace PeggysagePwa/Component/NewIssuePopup/Container */
export class NewIssuePopupContainer extends PureComponent {
    static propTypes = {
        payload: PropTypes.shape({
            title: PropTypes.string,
            order: OrderType
        })
    };

    static defaultProps = {
        payload: {
            title: '',
            order: {}
        }
    };

    containerFunctions = {
        // ...
    };

    containerProps() {
        const { payload } = this.props;

        return { payload };
    }

    render() {
        return (
            <NewIssuePopup
              { ...this.containerFunctions }
              { ...this.containerProps() }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NewIssuePopupContainer);
